var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 15H9.75C6.58209 15 3.79646 16.6367 2.19262 19.1107C2.0643 19.3086 1.75 19.2359 1.75 19C1.75 13.4772 6.22715 9 11.75 9V5.59612C11.75 4.75492 12.7254 4.2896 13.3792 4.81888L21.2899 11.2228C21.7843 11.623 21.7843 12.377 21.2899 12.7772L13.3792 19.1811C12.7254 19.7104 11.75 19.2451 11.75 18.4039V15ZM9.75 13H13.75V16.3078L19.0714 12L13.75 7.69224V11H11.75C9.3295 11 5.75 12.5 4.25 15C5.75 13.7711 8.33041 13 9.75 13Z",
    fill: "#212836"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.2db4cef9d5d5bd23208791ca6495e73e.svg";
export { ForwardRef as ReactComponent };